// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2aiua","errors":"Errors_errors__3Ya11"};